import React from 'react'
import { apiFetch } from '../../../fetchApi'

export const fetchSkills = ({ BeURL, setSkills }) => {
    apiFetch(`${BeURL}/fetch-skills`, {
        method: 'GET',
        credentials: 'include'
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                setSkills(data.skills)
            }
          
        })
        .catch(err => {
            console.log("Error in skills", err)
        })
}
